import {Line} from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import moment from 'jalali-moment';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
);
ChartJS.defaults.font.family = 'IRANYekanXVF';
export const options = {
  responsive: true,
  defaultFontFamily: "'IRANYekanXVF'",
  scales: {
    x: {
      grid: {
        display: false,
      },
    },
    y: {
      grid: {
        display: true,
      },
      ticks: {
        precision: 0,
      },
    },
  },
  plugins: {
    legend: {
      position: 'top' as const,
      display: false,
      labels: {
        font: {
          family: 'IRANYekanXVF', // right here
        },
      },
    },
    title: {
      display: false,
      text: 'Chart.js Line Chart',
    },
  },
};

type TChartInfo = {
  infoList: Array<IDashboardView>;
};

const ChartInfo = ({infoList}: TChartInfo) => {
  const labels = infoList
    ?.map(x => moment(x.date).format('jYYYY/jMM/jDD'))
    .reverse();

  const data = {
    labels,
    datasets: [
      {
        data: infoList?.map(x => x.count).reverse(),
        borderColor: '#9E3822',
        backgroundColor: '#9E3822',
      },
    ],
  };
  return (
    <>
      <Line options={options} data={data} />
    </>
  );
};

export default ChartInfo;
